export default function SearchResultsFilterEventModel(filterName: string, filterValue: string) {
    return {
        filterName: filterName,
        filterValue: filterValue,
    }
}